import { useState, useCallback } from 'react'

const TOUR_KEY = 'gcodr_tours_seen'

function loadSeen(): Set<string> {
  try {
    const raw = localStorage.getItem(TOUR_KEY)
    if (raw) return new Set(JSON.parse(raw))
  } catch { /* ignore */ }
  return new Set()
}

function saveSeen(seen: Set<string>): void {
  localStorage.setItem(TOUR_KEY, JSON.stringify([...seen]))
}

export function useTourState() {
  const [seen, setSeen] = useState<Set<string>>(loadSeen)

  const markSeen = useCallback((tourId: string) => {
    setSeen(prev => {
      const next = new Set(prev)
      next.add(tourId)
      saveSeen(next)
      return next
    })
  }, [])

  const shouldShow = useCallback((tourId: string) => !seen.has(tourId), [seen])

  const resetAll = useCallback(() => {
    setSeen(new Set())
    localStorage.removeItem(TOUR_KEY)
  }, [])

  return { shouldShow, markSeen, resetAll }
}
